import React from "react";

import AssignmentMenu from "@Components/groups/AssignmentMenu";
import { GroupContext, SystemContext } from "@Constants";
import { getSystemId, hasCapability } from "@Utils";
import { IAddAction } from "./types";

interface IProps {
    addAction?: IAddAction;
    title: JSX.Element;
    color: string;
}

const GroupsHeaderRoot: React.FC<IProps> = ({ addAction, title, color }: IProps) => {
    const canCreateRootGroups = hasCapability("UserGroup/Create", GroupContext, getSystemId()) && addAction !== null;

    return (
        <div id="groups-list-header-content">
            <table>
                <tbody>
                    <tr>
                        <td style={{ color: color }}>{title}</td>
                        <td></td>
                        <td>
                            {canCreateRootGroups ? (
                                <AssignmentMenu
                                    roleAssignments={[]}
                                    creditAssignments={[]}
                                    context={SystemContext}
                                    groupId={getSystemId()}
                                    page={0}
                                    userId={""}
                                    addAction={addAction}
                                    systemRolesOnly={false}
                                />
                            ) : null}
                        </td>
                        <td id="groups-list-header-close"></td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
};
export default GroupsHeaderRoot;